module.exports = __webpack_public_path__ + "img/s2.77fada9e.png";